import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { syncRawStepsOnce } from "../hooks/useSteps";
import { pedometerAvailable } from "../lib/native/pedometer";

/**
 * RouteStepsSync — Route 변경 시 걸음 sync 1회 실행 (네이티브 전용).
 *
 * 목적: 홈 탭 이탈 시 25초 sync interval이 중단되어 남의 걸음이 랭킹에 반영되지 않는 문제 해결.
 * 어떤 화면으로 이동하든 그 순간 최신 센서값을 서버에 전달해 랭킹 최신성을 보장.
 *
 * 원칙:
 * - useSteps·pedometer·네이티브 Java 로직 무변경. 기존 syncRawStepsOnce()만 재사용.
 * - 5초 debounce로 연속 이동 시 중복 호출 방지.
 * - 웹(nativeMode=false)은 기존 useSteps 흐름 그대로. 여기서는 no-op.
 * - 실패는 조용히 무시(기존 syncRawStepsOnce 규약).
 */
const DEBOUNCE_MS = 5000;

export default function RouteStepsSync() {
  const location = useLocation();
  const lastSyncAtRef = useRef(0);

  useEffect(() => {
    if (!pedometerAvailable()) return;
    const now = Date.now();
    if (now - lastSyncAtRef.current < DEBOUNCE_MS) return;
    lastSyncAtRef.current = now;
    // fire-and-forget · 반환값·에러 무시 (걸음 로직 무영향 원칙)
    syncRawStepsOnce().catch(() => {});
  }, [location.pathname]);

  return null;
}
